module.exports = __webpack_public_path__ + "img/mob3.1b93c2b1.png";